import type { TeacherAttendanceRow } from "@/types/tables";
import type { AttendanceRotations } from "../../pages/Dashboard";

export const buildTeacherAttendanceRows = (
  data: AttendanceRotations[],
): TeacherAttendanceRow[] => {
  const rows: TeacherAttendanceRow[] = [];

  for (const r of data) {
    for (const s of r.sessions) {
      const records = s.records ?? 0;
      const present = s.present ?? 0;
      const absent = Math.max(0, records - present);
      const rate = records ? Math.round((present / records) * 100) : 0;

      rows.push({
        rotationId: r._id,
        rotationDate: r.date,
        sessionId: s._id,
        sessionName: s.name,
        records,
        present,
        absent,
        rate,
        absentStudents: s.absentStudents,
        classes: s.classes,
      });
    }
  }

  return rows;
};
